import React, {useContext, useState} from 'react';

interface INotificationContext {
    notifications: Notification[],
    pushNotification: (arg: Partial<Notification>) => number,
    removeNotification: (id: number) => void
    pushError: (arg: Partial<Notification>) => number
}

interface Notification {
    id: number,
    message: string,
    severity: 'error' | 'warning' | 'success' | 'info'
}

const NotificationContext = React.createContext<INotificationContext>(null as any);


const useNotification = () => {
    const context = useContext(NotificationContext);
    return context;
};

const NotificationProvider: React.FC = (props) => {
    const [notifications, setNotifications] = useState<Notification[]>([]);

    const pushNotification = (notification: any, timeout = 8 * 1000) => {
        if (!notification)
            return;

        notification.id = Math.round(Math.random() * 10000);

        setNotifications(previousNotifications => [...previousNotifications, notification]);

        if (timeout)
            setTimeout(() => removeNotification(notification.id), timeout);

        return notification.id;
    };

    const pushError = ({ message }: Partial<Notification>) => {
        return pushNotification({ message, severity: 'error' });
    };

    const removeNotification = (id: any) => {
        setNotifications(previousNotifications => {
            const index = previousNotifications.findIndex(n => (n as any).id === id);
            if (index <= -1)
                return previousNotifications;
            else {
                const result = [...previousNotifications];
                result.splice(index, 1);
                return result;
            }
        });
    };

     return <NotificationContext.Provider value={{ pushNotification, removeNotification, pushError, notifications }}>
        {props.children}
    </NotificationContext.Provider>;
};
export { useNotification, NotificationProvider };
